import axios from "../../axios";

const getAllEvents = async (start, end, stylists) => {
  let start_date = new Date(start).toISOString();
  let end_date = new Date(end).toISOString();
  // console.log(start_date, end_date, "start_date, end_date");
  let byStylists = stylists ? `&stylist_id[$in]=${stylists}` : '';
  try {
    let { data } = await axios.get(
      `/appointments/calendar?appointment_date[$gte]=${start_date}&appointment_date[$lte]=${end_date}${byStylists}&status[$ne]=cancelled`
    )
  return { events: data.events };
  } catch (e) {
    console.log(e)
  }
}

const getWorkingHours = async (days, stylists) => {
  if (!days) return [];
  let byStylists = stylists ? `&stylist_id[$in]=${stylists}` : '&is_public=true';

  days = days.join(",");
  try {
    let { data } = await axios.get(
      `/settings/working_hours?day_of_week[$in]=${days}${byStylists}`
    )
    return data;
  } catch (e) {
    console.log(e)
  }
}

const saveStylistView = async (list) => {
  try {
    let dataPacket = {
      resource: "calendar",
      resource_tab: "stylist_view",
      settings_level: "user",
      data: list
    }

    let { data } = await axios.post(`/settings`, dataPacket);
    return data;
  } catch (e) {
    return null;
  }
}

const getStylistView = async () => {
  try {
    let { data } = await axios.get(`/settings/calendar/stylist_view`);
    return data;
  } catch (e) {
    return null;
  }
}

export {
  getAllEvents,
  getWorkingHours,
  saveStylistView,
  getStylistView
}